import clsx from 'clsx'
import React, { useId, useMemo } from 'react'

import { InputBlockContext } from './context'
import { InputBlockInput } from './Input'
import { InputBlockRow } from './Row'
import { InputBlockSelect } from './Select'

export interface InputBlockProps extends Omit<React.FieldsetHTMLAttributes<HTMLFieldSetElement>, 'className'> {
  children: React.ReactNode;
  description?: React.ReactNode;
  label?: React.ReactNode;
}

export function InputBlock ({ children, description, label, ...props }: InputBlockProps) {
  const descriptionId = useId()
  const portalId = useId()

  const contextValue = useMemo(() => ({ portalId }), [portalId])

  return (
    <div>
      <fieldset
        {...props}
        aria-describedby={description ? descriptionId : undefined}
      >
        {!!label && (
          <legend className='body-sm-bold text-gray-800 block mb-2'>
            {label}
          </legend>
        )}
        {!!description && (
          <div id={descriptionId} className='body-sm text-gray-500 mb-1'>
            {description}
          </div>
        )}
        <div className={clsx('flex flex-col', 'rounded-lg')}>
          <InputBlockContext.Provider value={contextValue}>
            {children}
          </InputBlockContext.Provider>
        </div>
      </fieldset>
      <div id={portalId} />
    </div>
  )
}

InputBlock.Input = InputBlockInput
InputBlock.Row = InputBlockRow
InputBlock.Select = InputBlockSelect
